import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import {
  getStoreInvoicePrinter,
  getStoreNormalA5A4Printer,
  getStoreTagPrinter,
  getUserData,
  getStorePOSEnabled,
  setStoreInvoicePrinter,
  setStoreNormalA5A4Printer,
  setStorePOSEnabled,
  setStoreTagPrinter,
  setStorePOSInvoicePrinterValue,
  setStorePOSTagPrinterValue,
  getStorePOSTagPrinterValue,
  getStorePOSInvoicePrinterValue,
  setStorePOSInvoicePrinterReceiptType,
  getStorePOSInvoicePrinterReceiptType,
} from "../../../utils/localStorage";
import TabMenu from "../../TabMenu";
import AdminMenu from "../../AdminMenu";

import qz from "qz-tray";
import { Button } from "primereact/button";
import ButtonLink from "../../../ButtonLink";
import { InputText } from "primereact/inputtext";

const StorePrinterSetting = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const { userProfileRole } = getUserData();
  const userRole = userProfileRole;

  const [isConnected, setIsConnected] = useState(false);
  const [printerInvoiceList, setPrinterInvoiceList] = useState([]);
  const [printerNormalA5A4List, setPrinterNormalA5A4List] = useState([]);
  const [printerTagList, setPrinterTagList] = useState([]);
  const [printerList, setPrinterList] = useState([]);
  const [tagPrinterPOSValue, setTagPrinterPOSValue] = useState("");
  const [tagPrinterPOSLocalValue, setTagPrinterPOSLocalValue] = useState("");
  const [invoicePrinterPOSValue, setInvoicePrinterPOSValue] = useState("");
  const [invoicePrinterPOSLocalValue, setInvoicePrinterPOSLocalValue] = useState("");
  

  const [posEnabled, setPosEnabled] = useState(false);
  const [invoicePosReceiptType, setInvoicePosReceiptType] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const findPrinters = async () => {
    try {
      const printers = await qz.printers.find();
      setPrinterList(printers);
    } catch (err) {
      console.error("Failed to find printers:", err);
    }
  };

  const findInvoicePrinters = async () => {
    try {
      const printers = await qz.printers.find();
      setPrinterInvoiceList(printers);
      setPrinterTagList([]);
      setPrinterNormalA5A4List([]);
    } catch (err) {
      console.error("Failed to find printers:", err);
    }
  };

  const findNormalA5A4Printers = async () => {
    try {
      const printers = await qz.printers.find();
      setPrinterNormalA5A4List(printers);
      setPrinterInvoiceList([]);
      setPrinterTagList([]);
    } catch (err) {
      console.error("Failed to find printers:", err);
    }
  };

  const findTagPrinters = async () => {
    try {
      const printers = await qz.printers.find();
      setPrinterTagList(printers);
      setPrinterNormalA5A4List([]);
      setPrinterInvoiceList([]);
    } catch (err) {
      console.error("Failed to find printers:", err);
    }
  };



  // Toggle POS setting and save

  // const handlePOSToggle = async () => {
  //   const newValue = !posEnabled;
  //   setPosEnabled(newValue);
  //   await setStorePOSEnabled(newValue);
  // };

  const handlePOSToggle = async () => {
    const newValue = !posEnabled;
    setPosEnabled(newValue);
    await setStorePOSEnabled(newValue); // must store boolean
    if (newValue === false) {
      await setStorePOSInvoicePrinterValue("");
      await setStorePOSTagPrinterValue("");
    } else {
      await setStoreInvoicePrinter("")
      await setStoreNormalA5A4Printer("")
      await setStoreTagPrinter("")
    }

    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchSelectedTagPrinter();
    fetchSelectedPOSInvoicePrinterValue();
    fetchSelectedPOSTagPrinterValue();
    fetchSelectedInvoicePrinterReceiptType();
  };

  const handlePOSInvoicePrinterValue = async () => {
    const newValue = invoicePrinterPOSValue;
    await setStorePOSInvoicePrinterValue(newValue);
    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchSelectedTagPrinter();
    fetchSelectedPOSInvoicePrinterValue();
    fetchSelectedPOSTagPrinterValue();
    fetchSelectedInvoicePrinterReceiptType();
  };

  const handlePOSInvoicePrinterReceiptType = async () => {
    const newValue = !invoicePosReceiptType;
    await setStorePOSInvoicePrinterReceiptType(newValue);
    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchSelectedTagPrinter();
    fetchSelectedPOSInvoicePrinterValue();
    fetchSelectedPOSTagPrinterValue();
    fetchSelectedInvoicePrinterReceiptType();
  };

  const handlePOSTagPrinterValue = async () => {
    const newValue = tagPrinterPOSValue;
    await setStorePOSTagPrinterValue(newValue);
    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchSelectedTagPrinter();
    fetchSelectedPOSInvoicePrinterValue();
    fetchSelectedPOSTagPrinterValue();
    fetchSelectedInvoicePrinterReceiptType();
  };

  const fetchSelectedPOSInvoicePrinterValue = async () => {
    try {
      const invoicePrinterPOSValue = await getStorePOSInvoicePrinterValue();
      setInvoicePrinterPOSValue(invoicePrinterPOSValue?.invoicePrinterPOSValue || "");
      setInvoicePrinterPOSLocalValue(invoicePrinterPOSValue?.invoicePrinterPOSValue || "");
    } catch {
      setInvoicePrinterPOSValue("");
      setInvoicePrinterPOSLocalValue("");
    }
  };

  const fetchSelectedPOSTagPrinterValue = async () => {
    try {
      const tagPrinterPOSValue = await getStorePOSTagPrinterValue();
      setTagPrinterPOSValue(tagPrinterPOSValue?.tagPrinterPOSValue || "");
      setTagPrinterPOSLocalValue(tagPrinterPOSValue?.tagPrinterPOSValue || "");
    } catch {
      setTagPrinterPOSValue("");
      setTagPrinterPOSLocalValue("");
    }
  };

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const [normalA5A4PrinterValue, setNormalA5A4PrinterValue] = useState("");
  const [tagPrinterValue, setTagPrinterValue] = useState("");

  const handleInvoicePrinterChange = async (selectedType) => {
    setInvoicePrinterValue(selectedType);
    await setStoreInvoicePrinter(selectedType);
    setPrinterInvoiceList([]);
  };

  const handleNormalA5A4PrinterChange = async (selectedType) => {
    setNormalA5A4PrinterValue(selectedType);
    await setStoreNormalA5A4Printer(selectedType);
    setPrinterNormalA5A4List([]);
  };

  const handleTagPrinterChange = async (selectedType) => {
    setTagPrinterValue(selectedType);
    await setStoreTagPrinter(selectedType);
    setPrinterTagList([]);
  };

  const fetchSelectedInvoicePrinterReceiptType = async () => {
    try {
      const invoicePrinterPOSReceiptTypeValue = await getStorePOSInvoicePrinterReceiptType();
      const value =
        invoicePrinterPOSReceiptTypeValue?.invoicePrinterPOSReceiptTypeValue === true ||
        invoicePrinterPOSReceiptTypeValue?.invoicePrinterPOSReceiptTypeValue === "true";
      setInvoicePosReceiptType(value);
    } catch {
      setInvoicePosReceiptType(false);
    }
  };

  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  const fetchSelectedNormalA5A4Printer = async () => {
    try {
      const selectedNormalA5A4PrinterData = await getStoreNormalA5A4Printer();
      setNormalA5A4PrinterValue(
        selectedNormalA5A4PrinterData?.normalA5A4Printer || ""
      );
    } catch {
      setNormalA5A4PrinterValue("");
    }
  };

  const fetchSelectedTagPrinter = async () => {
    try {
      const selectedTagPrinterData = await getStoreTagPrinter();
      setTagPrinterValue(selectedTagPrinterData?.tagPrinter || "");
    } catch {
      setTagPrinterValue("");
    }
  };

  // Fetch stored POS setting

  // const fetchPOSSetting = async () => {
  //   try {
  //     const selectedInvoicePrinterData = await getStorePOSEnabled();
  //     setPosEnabled(selectedInvoicePrinterData.storePOSEnabled ?? false);
  //   } catch {
  //     setPosEnabled(false);
  //   }
  // };

  const fetchPOSSetting = async () => {
    try {
      const data = await getStorePOSEnabled();

      const value =
        data?.storePOSEnabled === true ||
        data?.storePOSEnabled === "true";

      setPosEnabled(value);
    } catch {
      setPosEnabled(false);
    }
  };

  useEffect(() => {
    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchSelectedTagPrinter();
    connectToQZ();
    fetchPOSSetting();
    fetchSelectedPOSInvoicePrinterValue();
    fetchSelectedPOSTagPrinterValue();
    fetchSelectedInvoicePrinterReceiptType();
  }, []);

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Printer Setting
              </p>
            </div>
          </div>
          {userRole !== "BY_WAREHOUSE" &&
            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => setVisible(true)}
            >
              <i
                className="pi pi-bars"
                style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
              ></i>
            </div>}
        </div>
      </div>

      <div className="mx-4 my-3">

        <div className="flex flex-1 cursor-pointer">
          <div
            className="p-2 m-2"
            style={{
              borderRadius: 10,
            }}
          >
            <img
              src={"images/printer.png"}
              style={{
                height: 45,
                width: 45,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div className="flex-1">
              <p className="text-3xl font-semibold">POS Machine</p>
            </div>
            <div className="flex-1">
              <Button
                style={{ backgroundColor: posEnabled ? "#28a745" : "#dc3545" }}
                onClick={handlePOSToggle}
              >
                {posEnabled ? "Enabled" : "Disabled"}
              </Button>
            </div>
            <div className="flex-1">
              <p className="text-xl font-semibold">{!posEnabled ? "Click To Enable POS Printer" : "Click To Disabled POS Printer"}</p>
            </div>
          </div>
        </div>

        {!posEnabled && <div>
          <div className="flex flex-1 cursor-pointer">
            <div
              className="p-2 m-2"
              style={{
                borderRadius: 10,
              }}
            >
              <img
                src={"images/printer.png"}
                style={{
                  height: 45,
                  width: 45,
                }}
              />
            </div>
            <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
              <div className="flex-1">
                <p className="text-3xl font-semibold">Invoice Printer</p>
              </div>
              <div className="flex-1">
                <Button
                  style={{ backgroundColor: "#F5C621" }}
                  onClick={findInvoicePrinters}
                >
                  Choose Printer
                </Button>
              </div>
              <div className="flex-1">
                <p className="text-3xl font-semibold">{invoicePrinterValue}</p>
              </div>
            </div>
          </div>


          <div className="flex flex-1 cursor-pointer">
            <div
              className="p-2 m-2"
              style={{
                borderRadius: 10,
              }}
            >
              <img
                src={"images/printer.png"}
                style={{
                  height: 45,
                  width: 45,
                }}
              />
            </div>
            <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
              <div className="flex-1">
                <p className="text-3xl font-semibold">A5 & A4 Printer</p>
              </div>
              <div className="flex-1">
                <Button
                  style={{ backgroundColor: "#1F78D9" }}
                  onClick={findNormalA5A4Printers}
                >
                  Choose Printer
                </Button>
              </div>
              <div className="flex-1">
                <p className="text-3xl font-semibold">
                  {normalA5A4PrinterValue}
                </p>
              </div>
            </div>
          </div>
          {userRole !== "BY_WAREHOUSE" && (
            <div className="flex flex-1 cursor-pointer">
              <div
                className="p-2 m-2"
                style={{
                  borderRadius: 10,
                }}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    height: 45,
                    width: 45,
                  }}
                />
              </div>
              <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
                <div className="flex-1">
                  <p className="text-3xl font-semibold">Tag Printer</p>
                </div>
                <div className="flex-1">
                  <Button
                    style={{ backgroundColor: "#AD39BF" }}
                    onClick={findTagPrinters}
                  >
                    Choose Printer
                  </Button>
                </div>
                <div className="flex-1">
                  <p className="text-3xl font-semibold">{tagPrinterValue}</p>
                </div>
              </div>
            </div>
          )}
        </div>}


        {posEnabled && <div>
          <div className="flex flex-1 cursor-pointer">
            <div
              className="p-2 m-2"
              style={{
                borderRadius: 10,
              }}
            >
              <img
                src={"images/printer.png"}
                style={{
                  height: 45,
                  width: 45,
                }}
              />
            </div>
            <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
              <div className="flex-1">
                <p className="text-3xl font-semibold">POS Invoice Printer Receipt Type</p>
              </div>
              <div className="flex-1">
                <Button
                  style={{ backgroundColor: invoicePosReceiptType ? "#28a745" : "#dc3545" }}
                  onClick={handlePOSInvoicePrinterReceiptType}
                >
                  {invoicePosReceiptType ? "Auto Cutter" : "Non Auto Cutter"}
                </Button>
              </div>
              <div className="flex-1">
                <p className="text-xl font-semibold">{!invoicePosReceiptType ? "Click To Enable Auto Cutter Printer" : "Click To Enable Non-Auto Cutter Printer"}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-1 cursor-pointer">
          <div
            className="p-2 m-2"
            style={{
              borderRadius: 10,
            }}
          >
            <img
              src={"images/printer.png"}
              style={{
                height: 45,
                width: 45,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div className="flex-1">
              <p className="text-3xl font-semibold">POS Invoice Printer</p>
            </div>
            <div className="flex-1">
                <InputText
                  style={{width:'100%'}}
                  value={invoicePrinterPOSValue}
                  placeholder={
                    "Enter Invoice Printer Name etc., The Bluetooth Invoice Printer Name"
                  }
                  autoFocus={true}
                  onChange={(e) => {
                    setInvoicePrinterPOSValue(e.target.value);
                  }}
                />
            </div>
            <div className="flex-1 ml-4 flex">
                
                <div className="flex-1">
                  <Button
                    onClick={handlePOSInvoicePrinterValue}
                  >
                    {invoicePrinterPOSLocalValue ? 'Re-Submit' : 'Submit'}
                  </Button>
                </div>
                {invoicePrinterPOSLocalValue && <img
                  src={"images/checked.png"}
                  style={{
                    height: 45,
                    width: 45,
                    marginRight: 10,
                  }}
                />}
            </div>
          </div>
        </div>

        <div className="flex flex-1 cursor-pointer">
          <div
            className="p-2 m-2"
            style={{
              borderRadius: 10,
            }}
          >
            <img
              src={"images/printer.png"}
              style={{
                height: 45,
                width: 45,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div className="flex-1">
                <p className="text-3xl font-semibold">POS Tag Printer</p>
            </div>
            <div className="flex-1">
               <InputText
                  style={{ width: '100%' }}
                  value={tagPrinterPOSValue}
                  placeholder={
                      "Enter Tag Printer Name etc., The Bluetooth Tag Printer Name"
                  }
                  autoFocus={true}
                  onChange={(e) => {
                    setTagPrinterPOSValue(e.target.value);
                  }}
                />
            </div>
              <div className="flex-1 ml-4 flex">
                <div className="flex-1">
                  <Button
                    onClick={handlePOSTagPrinterValue}
                  >
                    {tagPrinterPOSLocalValue ? 'Re-Submit' : 'Submit'}
                  </Button>
                </div>
                {tagPrinterPOSLocalValue && <img
                  src={"images/checked.png"}
                  style={{
                    height: 45,
                    width: 45,
                    marginRight: 10,
                  }}
                />}
            </div>
          </div>
        </div>
        </div>
      }


        {printerInvoiceList.length > 0 && (
          <div>
            <div className="flex justify-content-center align-items-center">
              <p className="text-2xl font-bold">Available Invoice Printers:</p>
            </div>
            <div>
              {printerInvoiceList.map((printer, index) => (
                <div
                  key={index}
                  className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                  style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                  onClick={() => handleInvoicePrinterChange(printer)}
                >
                  <p
                    className="text-color text-lg font-normal uppercase"
                    style={{
                      "--text-color": "#75879B",
                    }}
                  >
                    {printer}
                  </p>
                  {invoicePrinterValue === printer && (
                    <div className="flex align-self-center">
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "20px", color: "#008EFF" }}
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {printerTagList.length > 0 && (
          <div>
            <div className="flex justify-content-center align-items-center">
              <p className="text-2xl font-bold">Available Tag Printers:</p>
            </div>
            <div>
              {printerTagList.map((printer, index) => (
                <div
                  key={index}
                  className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                  style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                  onClick={() => handleTagPrinterChange(printer)}
                >
                  <p
                    className="text-color text-lg font-normal uppercase"
                    style={{
                      "--text-color": "#75879B",
                    }}
                  >
                    {printer}
                  </p>
                  {tagPrinterValue === printer && (
                    <div className="flex align-self-center">
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "20px", color: "#008EFF" }}
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {printerNormalA5A4List.length > 0 && (
          <div>
            <div className="flex justify-content-center align-items-center">
              <p className="text-2xl font-bold">Available A5 & A4 Printers:</p>
            </div>
            <div>
              {printerNormalA5A4List.map((printer, index) => (
                <div
                  key={index}
                  className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                  style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                  onClick={() => handleNormalA5A4PrinterChange(printer)}
                >
                  <p
                    className="text-color text-lg font-normal uppercase"
                    style={{
                      "--text-color": "#75879B",
                    }}
                  >
                    {printer}
                  </p>
                  {normalA5A4PrinterValue === printer && (
                    <div className="flex align-self-center">
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "20px", color: "#008EFF" }}
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              alignSelf: "center",
            }}
          />
        </div>
      </div>
      {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" || userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
      <TabMenu />
    </div>
  );
};

export default StorePrinterSetting;
